import React from 'react';
import * as S from '../styled';
import * as ST from './styled';
import { dataQuestions } from './data-questions';

const renderQuestions = () => {
    return (
        <ST.Questions>
            {dataQuestions.map(item => {
                return (
                    <span key={item.id} itemScope itemProp='mainEntity' itemType='https://schema.org/Question'>
                        <ST.StyledAccordion
                            customTheme={ST.themeForAccordion}
                            title={<ST.QuestionTitle
                        >
                            {item.title}
                        </ST.QuestionTitle>}>
                            <ST.QuestionText
                                itemProp='text'
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                        </ST.StyledAccordion>
                    </span>
                );
            })}
        </ST.Questions>
    );
};

export const Questions = () => {
    return (
        <S.Section bgColor='#31363c'>
            <S.InnerContainer>
                <div itemScope itemType='https://schema.org/FAQPage'>
                    <S.SectionTitle isLight>Частые вопросы</S.SectionTitle>
                    {renderQuestions()}
                </div>
            </S.InnerContainer>
        </S.Section>
    );
};
